import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MenuIcon, MessageCircleIcon } from 'lucide-react';
import { Logo } from './Logo';
import { DesktopNav } from './DesktopNav';
import { MobileMenu } from './MobileMenu';
import { ActionLink } from '../ui/ActionLink';
import { contact } from '../../data/contact';
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  const close = useCallback(() => setMobileOpen(false), []);
  useEffect(() => setMobileOpen(false), [pathname]);
  return <header className="sticky top-0 z-40 bg-white" data-id="element-589" data-mp="vqw6b706ntdl">
      <div className="mx-auto flex h-[72px] max-w-content items-center justify-between gap-4 px-5 md:px-8" data-id="element-590" data-mp="vspckl6vwbl2">
        <Logo className="h-12 md:h-14" data-id="element-591" data-mp="qy35gu7u556s" />
        <DesktopNav data-id="element-592" data-mp="39a2idsspx2o" />
        <div className="flex items-center gap-2" data-id="element-593" data-mp="38qxtys5p56l">
          <a href={contact.whatsappLink} target="_blank" rel="noreferrer" aria-label={`WhatsApp ${contact.whatsappDisplay}`} className="hidden h-11 w-11 items-center justify-center rounded-[15px] border border-line text-ink transition-colors duration-150 hover:bg-mist md:inline-flex" data-id="element-594" data-mp="3ugwaujqgmnpv">
            <MessageCircleIcon className="h-5 w-5" data-id="element-595" data-mp="gm9ti4h4v7xa" />
          </a>
          <ActionLink to="/contact" size="sm" className="hidden sm:inline-flex" data-id="element-596" data-mp="ljjg7cd515hf">
            Make an enquiry
          </ActionLink>
          <button type="button" onClick={() => setMobileOpen(true)} aria-label="Open menu" aria-expanded={mobileOpen} className="flex h-11 w-11 items-center justify-center rounded-full text-ink transition-colors duration-150 hover:bg-mist lg:hidden" data-id="element-597" data-mp="3k41fn28l8xnk">
            <MenuIcon className="h-6 w-6" data-id="element-598" data-mp="1u956boc78pn" />
          </button>
        </div>
      </div>
      <MobileMenu open={mobileOpen} onClose={close} data-id="element-599" data-mp="19c8cbi4qi8ti" />
    </header>;
}